"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeSizeClass = exports.getNumber = exports.getTypeSizeFromFontSize = exports.TypeSizeDetails = void 0;
var TypeSize;
(function (TypeSize) {
    TypeSize["TYPE_100"] = "type-100";
    TypeSize["TYPE_200"] = "type-200";
    TypeSize["TYPE_300"] = "type-300";
    TypeSize["TYPE_400"] = "type-400";
    TypeSize["TYPE_500"] = "type-500";
    TypeSize["TYPE_600"] = "type-600";
    TypeSize["TYPE_700"] = "type-700";
    TypeSize["TYPE_800"] = "type-800";
    TypeSize["TYPE_900"] = "type-900";
})(TypeSize || (TypeSize = {}));
/**
 * Font size and line height specifications for standard type sizes.
 */
exports.TypeSizeDetails = (_a = {},
    _a[TypeSize.TYPE_100] = { fontSize: 10, lineHeight: 12 },
    _a[TypeSize.TYPE_200] = { fontSize: 12, lineHeight: 16 },
    _a[TypeSize.TYPE_300] = { fontSize: 14, lineHeight: 18 },
    _a[TypeSize.TYPE_400] = { fontSize: 16, lineHeight: 20 },
    _a[TypeSize.TYPE_500] = { fontSize: 18, lineHeight: 22 },
    _a[TypeSize.TYPE_600] = { fontSize: 22, lineHeight: 26 },
    _a[TypeSize.TYPE_700] = { fontSize: 28, lineHeight: 32 },
    _a[TypeSize.TYPE_800] = { fontSize: 36, lineHeight: 38 },
    _a[TypeSize.TYPE_900] = { fontSize: 56, lineHeight: 56 },
    _a);
/**
 * Get the TypeSize associated with a given numeric font size value, in pixels, without the unit indicator. For instance, 12.
 *
 * @param fontSize The font size value, without unit, for which to return the appropriate TypeSize
 */
var getTypeSizeFromFontSize = function (fontSize) {
    var typeSize = Object.keys(exports.TypeSizeDetails).filter(function (key) { return exports.TypeSizeDetails[key] && exports.TypeSizeDetails[key].fontSize === fontSize; });
    //TODO: HANDLE NON-STANDARD VALUES; GO TO NEAREST STANDARD SIZE, UP OR DOWN. CONFIRM WITH DAVE.
    return !typeSize[0] ? null : typeSize[0];
};
exports.getTypeSizeFromFontSize = getTypeSizeFromFontSize;
/**
 * Get the numeric type size value. For example 400, as a number, is returned for TypeSize.TYPE_400.
 *
 * @param typeSize
 */
var getNumber = function (typeSize) {
    return typeSize && parseInt(typeSize.substring(5), 10);
};
exports.getNumber = getNumber;
/**
 * Get the appropriate type size utility class for a given TypeSize.  For example, fds-type-400 for TypeSize.TYPE_400.
 *
 * @param typeSize
 */
var getTypeSizeClass = function (typeSize) {
    if (typeSize && Object.keys(TypeSize).filter(function (key) { return TypeSize[key] === typeSize; }).length !== 0) {
        return "fds-" + typeSize;
    }
    return null;
};
exports.getTypeSizeClass = getTypeSizeClass;
exports.default = TypeSize;
